<div class="window-slide-up app-modal-spinner" [class.on-prepare]="!state.isInited">
    <ng-container [ngSwitch]="state.currentPage">
        <ng-container *ngSwitchCase="0" [ngTemplateOutlet]="header1"> </ng-container>
        <ng-container *ngSwitchCase="1" [ngTemplateOutlet]="header2"> </ng-container>
    </ng-container>
    <div class="page-switch" [class.page-message]="state.currentPage==1">
        <form [formGroup]="state.form!">
            <div class="page">
                <ng-container [ngTemplateOutlet]="page1"></ng-container>
            </div>
            <div class="page">
                <div class="message-input">
                    <div class="warning-section">
                        <span
                            [ngClass]="[state.isMessageOptional ? 'optional-label' : 'require-label']">※{{state.isMessageOptional?'任意':'必須'}}</span>
                        <span class="require-label" *ngIf="isMessageError">メッセージを入力してください</span>
                    </div>
                    <textarea [placeholder]="'テキストを入力'" [class.error]="isMessageError"
                        formControlName="message"></textarea>
                    <span class="note-under" *ngIf="!state.isMessageOptional">メッセージの修正や追記が可能です。</span>
                </div>
            </div>

        </form>

    </div>

</div>


<ng-template #header1>
    <div class="header">
        <div class="close" (click)="closeModal(true)"> <mat-icon svgIcon="care-conne-close"></mat-icon></div>
        <div class="title-page">転送先</div>
        <div class="next-page" [class.disabled]="isMsgInputBtnDisabled()" (click)="toNextPage()">次へ</div>
    </div>
</ng-template>
<ng-template #header2>
    <div class="header">
        <div class="close" (click)="toPrevPage()"> <mat-icon svgIcon="care-conne-back"></mat-icon></div>
        <div class="title-page">メッセージ</div>
        <div class="next-page" [class.disabled]="isSendBtnDisabled()" (click)="submit()">送信</div>
    </div>
</ng-template>

<ng-template #page1>
    <div class="select-unit-section scroll-x mask-scroll">
        <div 
            *ngFor="let unit of state.units"
            class="unit-item"
            (click)="onLoadUsers(unit)"
            [ngClass]="{
                'selected': state.selectedUnit === unit
            }"
        >
            <div class="unit-name"> {{ unit.name }} </div>
        </div>
        <label class="empty" *ngIf="state.units.length == 0">
            ユニットがありません。
        </label>
    </div>
    <div 
        *ngIf="state.selectedUnit"
        class="select-student-section scroll-x mask-scroll"
    >
        <div 
            *ngFor="let student of state.students"
            class="student-item"
            (click)="onLoadRooms(student)"
            [ngClass]="{
                'selected': state.selectedUser === student
            }"
        >
            <div>
                {{ student?.name }}
            </div>
            <div class="selected-room-counter">
                {{ utils.bindingSelectedRoomCounter(state, student) }}
            </div>
        </div>
        <label class="empty" *ngIf="state.students.length == 0">
            このユニットのユーザーは記録がありません。
        </label>
    </div>
    <div *ngIf="state.selectedUser" class="search">
        <div class="form-search">

            <div class="input-shell">
                <mat-icon svgIcon="search" class="grey"></mat-icon>
                <input [placeholder]="'検索'" [(ngModel)]="state.searchUser" />
                <mat-icon svgIcon="care-conne-close" class="grey" (click)="resetSearch()"></mat-icon>
            </div>
            <div class="filter-section">
                <ng-container *ngFor="let filter of state.filters">
                    <div class="filter-pill" [class.inactive]="!filter.isActive" (click)="filterRoom.filterToggle(state, filter, store)">
                        <label>{{filter.name}}</label>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div *ngIf="state.selectedUser" class="list">
        <ng-container *ngFor="let room of rooms">
            <app-room-item-by-student [room]="room" (changeSelect)="selectRoom($event)"
                [isSelected]="isSelected(room)"></app-room-item-by-student>
        </ng-container>
        <label class="empty" *ngIf="rooms.length == 0">
            検索結果がありません。
        </label>

    </div>
</ng-template>